import { enableProdMode, importProvidersFrom } from '@angular/core';


import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { HeaderInterceptor } from '@app/_core/helpers/header-interceptor';
import { UnauthorizedInterceptor } from '@app/_core/helpers/unauthorized-interceptor';
import { routes } from '@app/routes';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom([
          NzModalModule,
        ]),
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy,
        },
        { provide: NZ_I18N, useValue: en_US },
        { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
          { provide: HTTP_INTERCEPTORS, useClass: UnauthorizedInterceptor, multi: true },
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
        provideRouter(routes),
    ]
})
  .catch(err => console.error(err));
